import { lazy, Suspense, useEffect } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import {connect} from 'react-redux';
import Proptypes from 'prop-types';
// layouts
import MainLayout from 'src/layouts/main';
import FormLayout from 'src/layouts/form';
import { LoadingScreen } from 'src/components/loading-screen';

import {SET_USER} from 'src/store/userReducer';
// config
// import { PATH_AFTER_LOGIN } from 'src/config-global';
//
import { useAuthContext } from 'src/auth/hooks';
import { mainRoutes, HomePage } from './main';
import { authRoutes } from './auth';
import { authDemoRoutes } from './auth-demo';
import { dashboardRoutes } from './dashboard';
import { componentsRoutes } from './components';


import { ArchiveRoutes } from './archive';
import { AccessLogsRoutes } from './accesslogs';
import { NewDashboardRoutes, RouterDashboardRoutes, PublicRoutes } from './newDashboard';
import { reservationRoutes } from './reservation';
import { statisticOrganizationRoutes } from './statistic';
import { formParticipantRoutes, formOrganizationRoutes } from './form';
import { DocumentOrganizationRoutes, DocumentParticipantRoutes } from './document';

import { BuilderRoutes, WebSiteRoute } from './builder';
import { TestRoutes } from './test';
import { SettingsOrgRoutes } from './settings';
import { formationsRoutes } from '../formations';
import { UserAdminRoutes, UserTraineesRoutes, ManagerRoutes } from './user';
import { SubscriptionAdminRoutes, SubscriptionOrgRoutes, SubscriptionGocardlessRoutes } from './subscription';
import { traineeOrganizationRoutes, traineeParticipantRoutes } from '../trainee';
import { TrainingsOrganizationRoutes, TrainingsParticipantRoutes } from './trainings';
import { ProgramOrganizationRoutes, ProgramParticipantRoutes } from './program';

const FormFillingOutStore = lazy(() =>
  import('src/pages/form/FormFillingOut').then((module) => ({
    default: module.FormFillingOutStore,
  }))
);

// ----------------------------------------------------------------------


export default function Router() {

  const  routes =   [

      ...RouterDashboardRoutes,

      ...PublicRoutes,

      // SET INDEX PAGE WITH HOME PAGE
      ...mainRoutes,

      // authentification
      ...authRoutes,
  
      // forms routes
      ...formOrganizationRoutes,

      // statistics routes
      ...statisticOrganizationRoutes,

      // Programs routes
      ...ProgramOrganizationRoutes,
      ...ProgramParticipantRoutes,

      // documents routes
      ...DocumentOrganizationRoutes,

      //  trainee routes
      // ...traineeOrganizationRoutes,

      // test routes
      ...TestRoutes,

      // settings routes
      ...SettingsOrgRoutes,

      // subscription routes
      ...SubscriptionOrgRoutes,

      //  trainee routes
      ...traineeParticipantRoutes,

      // trainings routes
      ...TrainingsOrganizationRoutes,

      // archive routes
      ...ArchiveRoutes,

      // manager routes
      ...ManagerRoutes,

      // Authentication Logs
      ...AccessLogsRoutes,

      // builder routes
      ...BuilderRoutes,
      ...WebSiteRoute,

      // new dashboard routes
      ...NewDashboardRoutes,
  
      // form routes
      ...formParticipantRoutes,

      // document routes
      ...DocumentParticipantRoutes,

      // trainings routes
      ...TrainingsParticipantRoutes,

      // reservations routes
      ...reservationRoutes,

      // subscription routes
      ...SubscriptionAdminRoutes,

      // Gocardless routes
      ...SubscriptionGocardlessRoutes,

      // user routes
      ...UserAdminRoutes,
      ...UserTraineesRoutes,

      // Request routes
      ...formationsRoutes,
 
      {
        path: '/forms/:id/filled/:participant',
        element: (
          <FormLayout>
            <Suspense fallback={<LoadingScreen />}>
              <FormFillingOutStore />
            </Suspense>
          </FormLayout>
        ),
      },

      // No match 404
      { path: '*', element: <Navigate to="/404" replace /> },
    ];

    return useRoutes(routes);
}

